export const iconFontAwesomeSciencePrescriptionBottle = (
	<i className="fa-solid fa-prescription-bottle"></i>
);
